export const akiles = {
  connectTitle: "Conecta tu cuenta de Akiles",
  connectHelp: "Te llevamos a Akiles para que autorices tu organización. No hace falta copiar ninguna clave.",
  connect: "Conectar con Akiles",
  opening: "Abriendo…",
  notConfigured: "Akiles aún no está configurado en el servidor. Avisa a soporte.",
  connectedTo: "Conectado a",
  test: "Probar",
  testing: "Probando…",
  disconnect: "Desconectar",
  mappingTitle: "Qué grupo abre cada alojamiento",
  mappingHelp: "En Akiles el acceso va por grupos, y cada grupo ya reúne las puertas que el huésped necesita (portal, planta, su puerta). Elige el grupo que le toca a cada uno.",
  commonEntrance: "Entrada común",
  none: "Sin asignar",
  save: "Guardar",
  saving: "Guardando…",
  loading: "Cargando…",
  noGroups: "Tu organización de Akiles no tiene ningún grupo. Créalos en Akiles y vuelve aquí.",
  pickOne: "Elige al menos un grupo.",
  noUrl: "Akiles no devolvió la dirección de conexión.",
  genericError: "No se pudo completar la operación.",
  commonEntranceHelp: "Puertas que usan todos (portal, garaje, piscina…)",
  unitHelp: "Su puerta, y lo que necesite además",
  pick: "Elegir grupo",
  addMore: "Añadir otro",
  remove: "Quitar",
  saved: "Guardado",
};
